import { Flex, Image, Text, Button, Box } from "@chakra-ui/react";
import { motion } from "framer-motion";

const LoadingAnimation = () => {
  return (
    <motion.div
      style={{ fontSize: "54px", fontWeight: "600", color: "#fff" }}
      animate={{ opacity: [0.3, 1, 0.3] }}
      transition={{ duration: 1.5, repeat: Infinity }}
    >
      000
    </motion.div>
  );
};

const StatItem = ({ title, count, loaded }) => {
  return (
    <Flex direction={"column"}>
      <Text fontSize={"24px"} fontWeight={"400"} color={"#B6B6B6"}>
        {title}
      </Text>
      <Flex direction={"row"} gap={"16px"} alignItems={"center"}>
        <Image src="/dot.svg" width={"26px"} height={"26px"} />
        {loaded ? <Text fontSize={"54px"} fontWeight={"600"}>{count}</Text> : <LoadingAnimation />}
      </Flex>
    </Flex>
  );
};

const Stats = () => {
  return (
    <Box
      position="relative"
      display="inline-flex"
      alignItems="center"
      padding="29px 106px"
      fontSize="16px"
      color="white"
      mt={"70px"}
      borderRadius="12px"
      background="linear-gradient(270deg, rgba(255, 255, 255, 0.0) 0%, rgba(255, 255, 255, 0.05) 100%)"
      _before={{
        content: '""',
        position: "absolute",
        inset: "0",
        borderRadius: "12px",
        padding: "1px",
        background:
          "linear-gradient(to right, rgba(255, 255, 255, 0.25) 25%, rgba(255, 255, 255, 0.00) 100%)",
        WebkitMask:
          "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
        WebkitMaskComposite: "xor",
        maskComposite: "exclude",
        pointerEvents: "none",
      }}
      width={"100%"}
    >
      <Flex
        direction={{base: "column", lg: "row"}}
        gap={"48px"}
        width={"100%"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <StatItem title={"Aktywni użytkownicy (24h)"} count={"500"} />
        <StatItem
          title={"Zarejestrowanych użytkowników na serwerze"}
          count={12000}
        />
        <StatItem
          title={"Zarejestrowanych użytkowników na forum"}
          count={15000}
        />
      </Flex>
    </Box>
  );
};

const Component = () => {
  return (
    <Flex
      direction={"column"}
      gap={"55px"}
      width={"100%"}
      alignItems={"center"}
      mt={"130px"}
    >
      <Flex direction={"column"} width={"80%"} gap={"34px"} align={"center"}>
        <Text
          fontSize="42px"
          fontWeight={"400"}
          align={"center"}
          width={{ base: "80%", lg: "60%" }}
          lineHeight={"135%"}
        >
          Autorski{" "}
          <Text as={"span"} fontWeight={"600"}>
            gamemode
          </Text>{" "}
          oraz{" "}
          <Text as={"span"} fontWeight={"600"}>
            wiele atrakcji
          </Text>
          !
        </Text>
        <Text
          fontSize="18px"
          fontWeight={"400"}
          color={"#B6B6B6"}
          align={"center"}
        >
          Nasz autorski gamemode to serce projektu, oferujące niezapomniane
          doznania. Zawiera różnorodne elementy, takie jak służby mundurowe,
          organizacje, motoryzację i działania przestępcze. Przygotowaliśmy
          wiele atrakcji, aby każda chwila w grze była wyjątkowa. Odkrywaj
          unikalne elementy, zdobywaj nagrody i ciesz się niekończącą rozrywką!
        </Text>
        <Button
            fontWeight={"400"}
            fontSize={"18px"}
            width={"fit-content"}
            as={"a"}
            href={"https://discord.socialproject.pl"}
            target="_blank"
            lineHeight="40px"
            height={"40px"}
            style={{ textDecoration: "none" }}
            backgroundColor={"#fff"}
            color={"#000"}
            _hover={{ backgroundColor: "#d6d6d6" }}
          >
            Dołącz na discord
          </Button>
      </Flex>

      <Stats />

      <Flex direction={"column"} width={"100%"} gap={"34px"} align={"center"} mt={"70px"}>
        <Text
          fontSize="42px"
          fontWeight={"400"}
          align={"center"}
          width={{ base: "90%", lg: "60%" }}
          lineHeight={"135%"}
        >
          Zobacz nasz <Text as={"span"} fontWeight={"600"}>ostatni film</Text>!
        </Text>
                <Box
                  height={"400px"}
                  width={{base: "100%", lg: "70%"}}
                  borderRadius={"23px"}
                  border={"1px solid rgba(255, 255, 255, 0.28)"}
                  overflow={"hidden"}
                  position={"relative"}
                >
                  <iframe width="100%" height="100%" src="https://www.youtube.com/embed/HmEavPuWqfQ?si=2xJX8dIf35ozD7AS" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                  </Box>
        </Flex>
    </Flex>
  );
};

export default Component;
